import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { FormGroup, FormBuilder } from '@angular/forms';
import { SocialsService, MenuService, WeatherFactService, SharedService,
  VoiceService, SearchService } from './../../services';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  constructor(
    private _socials: SocialsService,
    private _menu: MenuService,
    private _fact: WeatherFactService,
    private _shared: SharedService,
    private _voice: VoiceService,
    private breakpointObserver: BreakpointObserver,
    private cdr: ChangeDetectorRef,
    private _search: SearchService,
    private formBuilder: FormBuilder,
    private cookieService: CookieService,
  ) {
    if (window.hasOwnProperty('webkitSpeechRecognition')) {
      this._voice.init();
      this.showMicrophone = true;
    } else {
      this.showMicrophone = false;
    }
    this.form = this.formBuilder.group({
      search: ['']
    });
  }

  public form: FormGroup;

  langs = [
    { name: 'be', label: 'BY' },
    { name: 'ru', label: 'RU' },
    { name: 'en', label: 'EN' }
  ];
  activeLang = 1;
  socials = [];
  menuRoot = [];
  menu = {
    weather: [],
    observation: [],
    services: [],
    projects: [],
    information: []
  };
  obs = [];
  mobileMenuOpen;
  mobileMenuEnabled;
  activeMenu;
  openMenuTimeoutId;
  counties = {
    "DE": "Германия",
    "UK": "Англия",
    "PL": "Польша",
    "MA": "Марокко",
    "TR": "Турция",
    "LV": "Латвия",
    "JO": "Иордания",
    "BG": "Болгария",
    "EG": "Египет",
    "RU": "Россия",
    "DZ": "Алжир",
    "ES": "Испания",
    "LT": "Литва",
    "UA": "Украина",
    "IT": "Италия",
    "NL": "Нидерланды",
    "ME": "Черногория",
    "FI": "Финляндия",
    "RO": "Румыния",
    "GR": "Греция",
    "FR": "Франция",
    "TM": "Туркменистан",
    "CH": "Швейцария",
    "BY": "Беларусь",
    "HU": "Венгрия",
    "RS": "Сербия",
    "MD": "Молдова",
    "NO": "Норвегия",
    "MK": "Македония",
    "TN": "Тунис",
    "SK": "Словакия",
    "CZ": "Чехия",
    "BE": "Бельгия",
    "EE": "Эстония",
    "AU": "Австрия",
    "SE": "Швеция",
    "HR": "Хорватия",
    "IE": "Ирландия",
    "DK": "Дания",
    "CY": "Кипр",
    "PT": "Португалия",
    "SL": "Словения",
    "BA": "Босния и Герцеговина",
    "AL": "Албания"
  };
  cities = [];
  allCities;
  countriesIds = [];
  locationFromHeader = false;
  showCities = false;
  showCountries = false;
  showCitiesMobile = false;
  showCountriesMobile = false;
  selectedCity;
  selectedCountry;
  showMicrophone = false;

  layoutChanges = this.breakpointObserver.observe([
    'screen and (max-width: 1000px)'
  ]);

  // CITY
  setCity(city) {
    this._shared.changeCity(city);
    this.showCities = false;
    this.showCitiesMobile = false;
    this.selectedCountry = undefined;
    if (this.locationFromHeader) {
      this.locationFromHeader = false;
      this.mobileMenuOpen = false;
    }
  }
  setCountry(country) {
    this.showCountries = false;
    this.showCountriesMobile = false;
    this.selectedCountry = country;
  }
  getCities() {
    this._fact.allCities().subscribe(
      res => {
        this.allCities = res;
        this.countriesIds = Object.keys(res).map(v => ({id: v, name: this.counties[v]})).sort((a, b) => {
          if(a.name < b.name) { return -1; }
          if(a.name > b.name) { return 1; }
          return 0;
        });


		const setClosetCity = (longitude, latitude) => {
			// @ts-ignore
			const allCities = Object.values(res).flat();
            const closestCity = allCities.reduce((acc, currVal) => {
            const accHypo = Math.hypot(acc.lng - longitude, acc.lat - latitude);
            const currValHypo = Math.hypot(currVal.lng - longitude, currVal.lat - latitude);
                return accHypo > currValHypo ? currVal : acc;
            });
            this._shared.changeCity(closestCity);
		}

		// Установка города на основе геолокации
		navigator.permissions.query({ name: "geolocation" }).then((result) => {
			if (result.state !== "denied") {
				navigator.geolocation.getCurrentPosition((p) => {
					setClosetCity(p.coords.longitude, p.coords.latitude);
					}
				);
			} else {
				// // Установка города на основе IP
				// fetch("https://ipapi.co/json").then(async res => {
					// const location = await res.json();
					// setClosetCity(location.longitude, location.latitude);
				// }).catch(e => {});
			}
        });
      },
      err => {}
    );
  }

  // MENU
  menuMouseEnter(type: string) {
    this.openMenuTimeoutId && clearTimeout(this.openMenuTimeoutId);
    // this.activeMenu = type;
    this.openMenuTimeoutId = setTimeout(()=> this.activeMenu = type, 100);
  }
  menuMouseLeave() {
    this.openMenuTimeoutId && clearTimeout(this.openMenuTimeoutId);
    this.openMenuTimeoutId = setTimeout(()=> this.activeMenu = undefined, 100);
  }
  openLink(url) {
    window.open(url, '_blank');
  }
  extractGlob = (str) => str.replace(":glob:","");
  extractTransItem = (item, lang) => {
    if (lang === 0) return item.title_be;
    if (lang === 1) return item.title;
    if (lang === 2) return item.title_en;
  }
  rootMenuIds = {
    '0': 'Прогноз погоды',
    '1': 'Наблюдения',
    '2': 'Услуги',
    '3': 'Проекты',
    '4': 'Информация',
  }
  extractTransRootItem = (id, lang) => {
    if (this.menuRoot && this.menuRoot.length && this.menuRoot.length > 0) {
      if (lang === 0 && this.menuRoot[id]) return this.menuRoot[id].title_be ? this.menuRoot[id].title_be : this.rootMenuIds[id];
      if (lang === 1 && this.menuRoot[id]) return this.menuRoot[id].title ? this.menuRoot[id].title : this.rootMenuIds[id];
      if (lang === 2 && this.menuRoot[id]) return this.menuRoot[id].title_en ? this.menuRoot[id].title_en : this.rootMenuIds[id];
    } else {
      return this.rootMenuIds[id];
    }
  }

  getMenu() {
    this._menu.list().subscribe(
      res => {
        this.menu = res;
        this.menu['weather'] = this.menu['weather'].map(v => {
          if(v.link.includes(":glob:")) {
            v.global = true;
          }
          return v;
        });
        this.menu['observation'] = this.menu['observation'].map(v => {
          if(v.link.includes(":glob:")) {
            v.global = true;
          }
          return v;
        });
        this.menu['services'] = this.menu['services'].map(v => {
          if(v.link.includes(":glob:")) {
            v.global = true;
          }
          return v;
        });
        this.menu['projects'] = this.menu['projects'].map(v => {
          if(v.link.includes(":glob:")) {
            v.global = true;
          }
          return v;
        });
        this.menu['information'] = this.menu['information'].map(v => {
          if(v.link.includes(":glob:")) {
            v.global = true;
          }
          return v;
        });
        this.obs = this.menu['observation'];
      },
      err => {}
    );
  }
  getRootMenu() {
    this._menu.listRoot().subscribe(
      res => {
        this.menuRoot = res;

      },
      err => {}
    );
  }
  // CURRENT URL
  currentUrl;


  // SOCIALS
  showSocialList = false;
  showSocials = () => { this.showSocialList = true; };
  getSocials() {
    this._socials.list().subscribe(
      res => {
        this.socials = Object.keys(res).map(v => ({
          title: v,
          link: res[v]
        }));
      },
      err => {}
    );
  }

  // VOICE INPUT
  speaking = false;
  searchText = '';
  startInput() {
    this.speaking = true;
    this._voice.start();
  }
  editInput(event) {
    // console.log(event.target.value)
    // // this.speaking = true;
    this._voice.edit(event.target.value);
  }
  stopInput() {
    this.speaking = false;
    this._voice.stop();
    console.log(this._voice, this._voice.tempWords);
    // this.searchText = this._voice.text;
    this.form.controls['search'].setValue(this._voice.text);
    this.search(this.form.value.search);
  }

  ngAfterViewInit() {
    this.layoutChanges.subscribe(result => {
      if (!result.breakpoints['screen and (max-width: 1000px)']) {
        this.mobileMenuOpen = false;
        this.mobileMenuEnabled = false;
      } else {
        this.mobileMenuEnabled = true;
      }
    });
    this.cdr.detectChanges();
  }

  // Search
  searchResult;
  showList = false;
  protectedShowList = false;
  test() {
    // console.log('test')
  }
  search(text) {
    this._search.search({ search: text }).subscribe(
      res => {
        this.searchResult = res;
        // console.log(res);
      },
      err => {}
    );
  }
  setWeatherStationFromSearch(item) {
    item.name = item.title;
    // delete item.title;
    this.setCity(item);
  }

  // TimeUTC
  timeUTC;
  changeTime() {
    this._shared.changeTime(!this.timeUTC);
  }

  ngOnInit() {
    // console.log(this.selectedCountry);
    let currentLang = this.cookieService.get('googtrans').replace('/ru/','');
    if (currentLang === 'be') {
      this.activeLang = 0;
    } else if (currentLang === 'ru') {
      this.activeLang = 1;
    } if (currentLang === 'en') {
      this.activeLang = 2;
    }
    this.getSocials();
    this.getRootMenu();
    this.getMenu();
    this._shared.currentCity.subscribe(city => {
      this.selectedCity = city;
      this.selectedCountry = city['country'];
    });
    this._shared.currentTime.subscribe(time => {
      this.timeUTC = time;
      // console.log(!this.timeUTC ? this.selectedCity.timezone : 0);
    });
    this._shared.currentUrl.subscribe(url => {
      // console.log('url',url);
      this.currentUrl = url;
    });
    this.getCities();
  }

}
